var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGmat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#F8CD5B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4603_3903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2362 73.24C37.3722 71.576 36.1722 70.328 34.6362 69.496C33.1002 68.632 31.3242 68.2 29.3082 68.2C27.1002 68.2 25.1322 68.696 23.4042 69.688C21.6762 70.68 20.3162 72.088 19.3242 73.912C18.3642 75.736 17.8842 77.848 17.8842 80.248C17.8842 82.648 18.3642 84.776 19.3242 86.632C20.3162 88.456 21.6762 89.864 23.4042 90.856C25.1322 91.848 27.1002 92.344 29.3082 92.344C32.2842 92.344 34.7002 91.512 36.5562 89.848C38.4122 88.184 39.5482 85.928 39.9642 83.08H27.4362V78.712H45.8202V82.984C45.4682 85.576 44.5402 87.96 43.0362 90.136C41.5642 92.312 39.6282 94.056 37.2282 95.368C34.8602 96.648 32.2202 97.288 29.3082 97.288C26.1722 97.288 23.3082 96.568 20.7162 95.128C18.1242 93.656 16.0602 91.624 14.5242 89.032C13.0202 86.44 12.2682 83.512 12.2682 80.248C12.2682 76.984 13.0202 74.056 14.5242 71.464C16.0602 68.872 18.1242 66.856 20.7162 65.416C23.3402 63.944 26.2042 63.208 29.3082 63.208C32.8602 63.208 36.0122 64.088 38.7642 65.848C41.5482 67.576 43.5642 70.04 44.8122 73.24H38.2362ZM86.3532 63.64V97H80.8812V74.152L70.7052 97H66.9132L56.6892 74.152V97H51.2172V63.64H57.1212L68.8332 89.8L80.4972 63.64H86.3532ZM113.657 90.184H99.6893L97.2893 97H91.5773L103.529 63.592H109.865L121.817 97H116.057L113.657 90.184ZM112.121 85.72L106.697 70.216L101.225 85.72H112.121ZM148.566 63.64V68.104H139.686V97H134.214V68.104H125.286V63.64H148.566Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4603_3903",
    x: 8.26807,
    y: 63.207,
    width: 144.298,
    height: 43.0801,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4603_3903"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4603_3903",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmat);
export default __webpack_public_path__ + "static/media/GMAT.d77daa788250352c7d76401f4b3dc351.svg";
export { ForwardRef as ReactComponent };